export const ORIGIN = {
  CLASS_STUDENT_LESSON_PROGRESS: 'class_student_lesson_progress',
  QUESTION_SET: 'lesson_questions',
  QUESTION_SET_RESULTS_GRID: 'question_set_results_grid',
  STAFF_RIBBON: 'staff_ribbon',
  STUDENT_COURSE_PROGRESS: 'student_course_progress',
  UNKNOWN: 'unknown',
  COURSES_PAGE: 'courses_page',
  COURSE_PAGE: 'course_page',
  TOPIC_PAGE: 'topic_page',
  TASK_PAGE: 'task_page',
};
